import { render } from "./ExibFases.vue?vue&type=template&id=542cc808&scoped=true"
import script from "./ExibFases.vue?vue&type=script&lang=js"
export * from "./ExibFases.vue?vue&type=script&lang=js"

import "./ExibFases.vue?vue&type=style&index=0&id=542cc808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542cc808"]])

export default __exports__